import { LoginForm } from 'components/LoginForm/LoginForm';

export const UnAuthenticatedView: React.FC = () => {
    return <LoginForm />;
};